<template>
  <OLink
    :href="card.url"
    class="w-full h-full flex p-6 gap-6 rounded-[20px] hover:opacity-95 transition-opacity duration-200 justify-between"
    :style="{ background: card.background }"
  >
    <div class="flex flex-col justify-between items-start">
      <h3 class="text-white text-24 leading-32 font-semibold line-clamp-2">{{ card.title }}</h3>
      <p class="text-white text-md font-medium flex items-center gap-1">
        Oku
        <OIcon icon="right-white" class="w-4 h-4" />
      </p>
    </div>

    <OImage :src="card.image" :alt="card.title" class="object-contain top-4 right-4 w-[82px] h-[82px]" />
  </OLink>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { OLink, OImage, OIcon } from '~/modules/common/components/ui';
export default defineComponent({
  components: {
    OLink,
    OImage,
    OIcon,
  },

  props: {
    card: {
      type: Object,
      required: true,
    },
  },

  setup() {},
});
</script>

<style scoped>
.astrology-widget-card {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
</style>
